/**
 * ai翻译
 */

// 获取code
const getCode = () => {
  const tag = document.getElementsByTagName("meta")["ai-translation"];
  if (tag) return tag.content;
};

// 加载ai翻译sdk
const fetchSmartTranslation = (code) => {
  fetch("https://cn-x-gateway.cainiao.com/cone/cn-panda/get-unified-config", {
    mode: "cors",
    method: "POST",
    cache: "no-cache",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      domain: location.host,
      code,
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res && res.data) {
        if (res.data.smartTranslationUrl) {
          const ts = document.createElement("script");
          ts.src = res.data.smartTranslationUrl;
          ts.async = false;
          document.head.appendChild(ts);
        }
        window.__PANDA = window.__PANDA || {};
        window.__PANDA.pluginConfig = res.data;
      }
    });
};

// 配置是否静默开启
const openSmartTranslation = (isOpen) => {
  localStorage.setItem(
    "i18n.smartTranslation.config",
    JSON.stringify({ open: isOpen })
  );
};

export const initSmartTranslation = () => {
	const code = getCode();
  const { isOpen = false } =
  (window.__global_config__ &&
    window.__global_config__.aiTranslationConfig) ||
  {};
	if (!code || !isOpen) return;

  fetchSmartTranslation(code);
	openSmartTranslation(isOpen);
};
